<template>
  <AvsTabs v-model="tab">
    <template v-slot:tabs>
      <v-tab key="general">
        {{ $t("commons.general") }}
      </v-tab>
      <v-tooltip
        bottom
        :disabled="uniqueProject"
      >
        <template v-slot:activator="{ on }">
          <div v-on="on">
            <v-tab
              style="height: 100%"
              :disabled="!uniqueProject"
              key="nc"
            >
              {{ $tc("categories.nonconformity.name", 1) }}
            </v-tab>
          </div>
        </template>
        <span>{{ $t("messages.information.select_project") }}</span>
      </v-tooltip>
    </template>

    <template v-slot:items>
      <v-tab-item key="general">
        <MenuFilters
          class="pt-2"
          :projects="projects"
          :mainFilters="mainFilters"
          :show="tab === 0"
        />
        <DashboardGeneral
          :companyId="companyId"
          :mainFilters="mainFilters"
        />
      </v-tab-item>
      <v-tab-item key="nc">
        <DashboardNonConformity
          :companyId="companyId"
          :mainFilters="mainFilters"
        />
      </v-tab-item>
    </template>
  </AvsTabs>
</template>

<script>
import { CompanyService } from "@/services"

export default {
  components: {
    AvsTabs: () => import("@/components/generics/general/AvsTabs.vue"),
    DashboardGeneral: () => import("./DashboardGeneral.vue"),
    DashboardNonConformity: () => import("./DashboardNonConformity.vue"),
    MenuFilters: () => import("@/components/ri3/reports/MenuFilters.vue")
  },
  name: "DashboardReports",
  data() {
    return {
      projects: [],
      mainFilters: {
        project: []
      },
      tab: 0,
      uniqueProject: false
    }
  },
  mounted() {
    this.fetchProjects()
  },
  methods: {
    fetchProjects() {
      CompanyService.projects.get(this.companyId).then(response => {
        this.projects = this.projects.concat(response)
        this.mainFilters.project = this.projects
      })
    }
  },
  computed: {
    companyId() {
      return this.$store.state.app.company.pk
    }
  },
  watch: {
    "mainFilters.project.id": {
      handler(newValue) {
        if (this.mainFilters.project.length != 1) {
          this.uniqueProject = false
        } else {
          this.uniqueProject = true
        }
      },
      deep: true
    }
  }
}
</script>
